import { withInstall } from '@sgui-plus/utils/with-install'

import Tag from './src/tag.vue'

export const SgTag = withInstall(Tag)
export default SgTag

export * from './src/tag'
